import AntdStepsWithPanel from 'components/AntdStepsWithPanel/index'
import Button from 'components/Button/index'
import { CollapseComp } from 'components/CollapseStyle/index'
import DriveStatus from 'modules/Drives/ViewDriveRole/IndividualDriveTable/DriveStatus/index'
import {
  Container,
  LeftDiv,
  RoundDiv,
  ShortListButton,
  StepRoundFlex,
  StepsFlex,
  StickyDiv,
  Titlediv,
} from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/style'
import React, { useEffect, useState } from 'react'
import { getZeroBeforeInt } from 'utils/getZeroBeforeInt'
import CollapseText from '../InterviewDetails/CollapseText/index'
import UpdateStatus from '../InterviewDetails/UpdateStatus/index'

const { Panel } = CollapseComp

const RoundsSteps = ({
  setScheduleDrawer,
  setCandidateInfo,
  rolesMetrics,
  candidateInterviewDetails,
  candidateInfoData,
  updateInterviewStatus,
  driveId,
  roleId,
  getCandidateList,
  addCorporateBranch,
  getRoleMetrics,
  setSelectedCandidate,

  getSingleCandidateInterviewDetails,
  interViewerList,
  createInterview,
  driveInterViewerList,
  getDriveInterviewerList,
  driveData,
  candidateDeatils,
  getInterViewLocation,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  listOfCountries,
  listOfStates,
  listOfCities,
  interViewData,
  setCandidateInfoData,
  corporateLocationsList,
  getCorporateLocationsList,
  getGroupDiscussionList,
  groupList,
  UpdateScheudle,
  ids,
  setNotification,
  notificationData,
  reasonItem,
  getDriveRoleCandidatesList,
  setSelectedCandidateId,
}) => {
  const [updateStatus, setUpdateStatus] = useState(false)
  const [completedStep, setCompletedStep] = useState(1)

  useEffect(() => {
    let names = rolesMetrics[0]?.rounds?.map(({ roundName }, index) => {
      return roundName
    })
    setCompletedStep(names?.indexOf(candidateInfoData?.stage))
  }, [candidateInfoData, rolesMetrics])

  const getCurrentRoundInfo = roundName => {
    let roundInfo =
      candidateInterviewDetails?.candidateInterviewDetails?.filter(data => {
        if (data?.interview?.interviewRound === roundName) {
          return data
        }
      })[0]
    return roundInfo
  }

  const handleUpadate = () => {
    setUpdateStatus(true)
    setCandidateInfo(false)
  }

  const genExtra = () => {
    return (
      <StepRoundFlex>
        {candidateInfoData?.status === 'SCHEDULED' ||
        candidateInfoData?.status === 'HOLD' ||
        candidateInfoData?.type === 'EXTERNAL_ASSESMENT' ? (
          <Button.Primary
            width="117px"
            height="32px"
            text="Update Status"
            onClick={handleUpadate}
          />
        ) : null}
        {(candidateInfoData?.status === 'SELECTED' ||
          candidateInfoData?.status === 'REJECTED') && (
          <div>
            <DriveStatus
              status={candidateInfoData?.status}
              offerStatus={candidateInfoData?.offerStatus}
            />
          </div>
        )}
      </StepRoundFlex>
    )
  }

  const stepsData = rolesMetrics[0]?.rounds
    ?.slice(0, rolesMetrics[0]?.rounds?.length - 1)
    ?.map((round, index) => {
      return {
        key: index,
        activeKey: index,
        title: (
          <CollapseComp
            key={index + 'roleMetrics'}
            defaultActiveKey={
              candidateInfoData?.stage === round?.roundName && [index + 1]
            }
            expandIconPosition={'end'}
            accordion
            bordered={
              candidateInfoData?.stage === round?.roundName &&
              candidateInfoData?.status !== 'SHORTLISTED'
            }
          >
            <Panel
              header={
                <StepsFlex spaceBetween>
                  <StepRoundFlex column>
                    <RoundDiv>Rounds{getZeroBeforeInt(index + 1)}</RoundDiv>
                    <Titlediv>{round?.roundName}</Titlediv>
                  </StepRoundFlex>
                  {candidateInfoData?.stage === round?.roundName && genExtra()}
                  {index < completedStep ? (
                    <ShortListButton>Shortlisted</ShortListButton>
                  ) : null}
                </StepsFlex>
              }
              key={index + 1}
              collapsible={
                getCurrentRoundInfo(round?.roundName) === false &&
                candidateInterviewDetails?.candidateInterviewDetails?.length !==
                  0 &&
                'disabled'
              }
            >
              {!!getCurrentRoundInfo(round?.roundName) !== false && (
                <p>
                  <CollapseText
                    interviewRoundInfo={getCurrentRoundInfo(round?.roundName)}
                    interviwerDeatils={
                      candidateInterviewDetails?.interviewerDetails?.data
                        ?.interviewere
                    }
                    candidateInfoData={candidateInfoData}
                    interViewerList={interViewerList}
                    rolesMetrics={rolesMetrics}
                    createInterview={createInterview}
                    driveInterViewerList={driveInterViewerList}
                    getDriveInterviewerList={getDriveInterviewerList}
                    driveData={driveData}
                    getCandidateList={getCandidateList}
                    candidateDeatils={candidateDeatils}
                    getRoleMetrics={getRoleMetrics}
                    addCorporateBranch={addCorporateBranch}
                    getInterViewLocation={getInterViewLocation}
                    interViewData={interViewData}
                    getListOfCountries={getListOfCountries}
                    getListOfStates={getListOfStates}
                    getListOfCities={getListOfCities}
                    listOfCountries={listOfCountries}
                    listOfStates={listOfStates}
                    listOfCities={listOfCities}
                    setCandidateInfoData={setCandidateInfoData}
                    corporateLocationsList={corporateLocationsList}
                    getCorporateLocationsList={getCorporateLocationsList}
                    getGroupDiscussionList={getGroupDiscussionList}
                    groupList={groupList}
                    UpdateScheudle={UpdateScheudle}
                    ids={ids}
                    roundName={round?.roundName}
                    setNotification={setNotification}
                    setCandidateInfo={setCandidateInfo}
                    notificationData={notificationData}
                    reasonItem={reasonItem}
                    getDriveRoleCandidatesList={getDriveRoleCandidatesList}
                  />
                </p>
              )}
            </Panel>
          </CollapseComp>
        ),
      }
    })

  return (
    <>
      <Container>
        <LeftDiv>
          <StickyDiv>
            <AntdStepsWithPanel
              current={completedStep}
              steps={stepsData}
              candidateInfoData={candidateInfoData}
            />
          </StickyDiv>
        </LeftDiv>
      </Container>
      {updateStatus && (
        <UpdateStatus
          updateStatus={updateStatus}
          setUpadateStatus={setUpdateStatus}
          setCandidateInfo={setCandidateInfo}
          candidateInfoData={candidateInfoData}
          interviwerDeatils={
            candidateInterviewDetails?.interviewerDetails?.data?.interviewere
          }
          rolesMetrics={rolesMetrics}
          updateInterviewStatus={updateInterviewStatus}
          driveId={driveId}
          roleId={roleId}
          getCandidateList={getCandidateList}
          getRoleMetrics={getRoleMetrics}
          setSelectedCandidate={setSelectedCandidate}
          setSelectedCandidateId={setSelectedCandidateId}
          getSingleCandidateInterviewDetails={
            getSingleCandidateInterviewDetails
          }
          candidateInterviewDetails={candidateInterviewDetails}
        />
      )}
    </>
  )
}

export default RoundsSteps
